module.exports = __webpack_public_path__ + "media/images/ogp-524b676100c1874e8d9f1db74aa63bc3.png";